import {
  startFunnelSession,
  recordFunnelStep,
  endFunnelSession,
  getFunnelSessionState,
} from "@/utils/behaviorTracker";
import { safeTrack } from "./track";
import { PAGE_KEYS } from "./pageKeys";

function resolveDepositPageKey(depositType) {
  if (depositType === "crypto") return PAGE_KEYS.DEPOSIT_CRYPTO;
  return PAGE_KEYS.DEPOSIT_FIAT;
}

function resolvePageKey(pageKey, depositType) {
  return pageKey || resolveDepositPageKey(depositType);
}

function depositPage(pagePath) {
  return pagePath || (typeof window !== "undefined" ? window.location.pathname : "");
}

/** @param {{ entry: string; pagePath?: string; pageKey?: string; depositType?: string }} params */
export function trackDepositEntryClick({ entry, pagePath, pageKey, depositType }) {
  startFunnelSession("deposit");
  recordFunnelStep(1);
  return safeTrack("deposit_entry_click", {
    page: depositPage(pagePath),
    properties: { entry, page_key: resolvePageKey(pageKey, depositType) },
  });
}

export function trackDepositPageView({ depositType, pagePath, pageKey }) {
  recordFunnelStep(2, { depositType });
  return safeTrack("deposit_page_view", {
    page: depositPage(pagePath),
    properties: { page_key: resolvePageKey(pageKey, depositType), deposit_type: depositType },
  });
}

export function trackDepositMethodSelect({
  methodId,
  currency,
  depositType,
  pagePath,
  pageKey,
}) {
  recordFunnelStep(3, { depositType });
  return safeTrack("deposit_method_select", {
    page: depositPage(pagePath),
    properties: {
      page_key: resolvePageKey(pageKey, depositType),
      method_id: String(methodId || ""),
      currency: String(currency || "").toUpperCase(),
      deposit_type: depositType,
    },
  });
}

export function trackDepositAmountConfirm({
  amount,
  currency,
  depositType,
  pagePath,
  pageKey,
}) {
  recordFunnelStep(4, { depositType });
  return safeTrack("deposit_amount_confirm", {
    page: depositPage(pagePath),
    properties: {
      page_key: resolvePageKey(pageKey, depositType),
      amount: String(amount),
      currency: String(currency || "").toUpperCase(),
      deposit_type: depositType,
    },
  });
}

export function trackDepositFail({ errorCode, depositType, pagePath, pageKey }) {
  return safeTrack("deposit_fail", {
    page: depositPage(pagePath),
    properties: {
      page_key: resolvePageKey(pageKey, depositType),
      error_code: String(errorCode || "UNKNOWN"),
      deposit_type: depositType,
    },
  });
}

export function trackDepositAbandon({ lastStep, depositType, pagePath, pageKey }) {
  const state = getFunnelSessionState();
  const step = lastStep != null ? lastStep : state?.lastStep || 1;
  const type = depositType || state?.depositType || "fiat";
  safeTrack("deposit_abandon", {
    page: depositPage(pagePath),
    properties: {
      page_key: resolvePageKey(pageKey, type),
      last_step: Number(step),
      deposit_type: type,
    },
  });
  endFunnelSession();
}

export function mapDepositOptionIdToType(id) {
  if (id === "crypto") return "crypto";
  if (id === "thirdParty") return "third_party";
  return "fiat";
}
